import { render } from "./description.vue?vue&type=template&id=1a4c78af&scoped=true"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"

import "./description.vue?vue&type=style&index=0&id=1a4c78af&lang=scss&scoped=true"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4c78af"]])

export default __exports__